import OrganisationListingList from "./OrganisationListingList";

export default {
    list: OrganisationListingList,
};
